import type { ComponentType, ReactNode } from "react";

// LDF: Leere Ansicht mit großem Symbol statt nur einer Textzeile – auf allen Bildschirmgrößen gleich.
export const EmptyState = ({
  Icon,
  title,
  text,
  children,
}: {
  Icon: ComponentType<{ className?: string }>;
  title: string;
  text?: ReactNode;
  children?: ReactNode;
}) => (
  <div className="flex flex-col items-center gap-2 px-4 py-10 text-center">
    <span className="relative mb-2 flex h-20 w-20 items-center justify-center">
      <span className="absolute inset-0 rounded-full bg-primary/10" />
      <span className="absolute inset-3 rounded-full bg-primary/15" />
      <Icon className="relative h-9 w-9 text-primary" />
    </span>
    <p className="font-medium">{title}</p>
    {text && <p className="max-w-sm text-sm text-muted-foreground">{text}</p>}
    {children}
  </div>
);
